// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expiration-select-r1WG0D{gap:8px;display:flex}.expiration-select-r1WG0D .semi-form-field{width:100%;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expiration-select": `expiration-select-r1WG0D`,
	"expirationSelect": `expiration-select-r1WG0D`
};
export default ___CSS_LOADER_EXPORT___;
